var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDivide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 6.5V42.5",
    stroke: "#2A2E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2 2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7445 33.9999L20.4997 28.9495C20.8093 28.771 21 28.4407 21 28.0833V19.0766C21 18.7197 20.8099 18.3899 20.501 18.2111L12.0149 13.2981C11.6976 13.1144 11.3052 13.119 10.9924 13.3102L2.97801 18.2079C2.68105 18.3894 2.4998 18.7122 2.49946 19.0602L2.49079 28.0827C2.49045 28.4404 2.68121 28.7711 2.99107 28.9499L11.7445 33.9999Z",
    fill: "#087E38"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7445 23.6784V34.0004L2.99051 28.95C2.68095 28.7714 2.49023 28.4412 2.49023 28.0839V18.6953",
    stroke: "#2A2E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9984 18.3398V28.0843C20.9984 28.4417 20.8077 28.7719 20.4981 28.9505L11.7441 34.0009",
    stroke: "#2A2E3C",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7445 13L2.49023 18.339L11.7445 23.678L20.9987 18.339L11.7445 13Z",
    fill: "white",
    stroke: "#2A2E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3046 21.5415L6.5 15.9993L8.18591 15.1348L17.4401 20.4737V23.3212L16.3724 22.9653L15.3046 24.7449V21.5415Z",
    fill: "#087E38",
    stroke: "#2A2E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5013 25.5662V32.7016L11.168 33.0875V23.8084L3 19V20.5L10.0157 24.7087C10.317 24.8894 10.5013 25.215 10.5013 25.5662Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2542 33.9999L45.0094 28.9495C45.319 28.771 45.5098 28.4407 45.5098 28.0833V19.0766C45.5098 18.7197 45.3196 18.3899 45.0108 18.2111L36.5246 13.2981C36.2073 13.1144 35.815 13.119 35.5021 13.3102L27.4878 18.2079C27.1908 18.3894 27.0096 18.7122 27.0092 19.0602L27.0006 28.0827C27.0002 28.4404 27.191 28.7711 27.5008 28.9499L36.2542 33.9999Z",
    fill: "#087E38"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2542 23.6784V34.0004L27.5003 28.95C27.1907 28.7714 27 28.4412 27 28.0839V18.6953",
    stroke: "#2A2E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5081 18.3398V28.0843C45.5081 28.4417 45.3174 28.7719 45.0079 28.9505L36.2539 34.0009",
    stroke: "#2A2E3C",
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2542 13L27 18.339L36.2542 23.678L45.5085 18.339L36.2542 13Z",
    fill: "white",
    stroke: "#2A2E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8143 21.5415L30.916 16.2026L32.6957 15.1348L41.9499 20.4737V23.3212L40.8821 22.9653L39.8143 24.7449V21.5415Z",
    fill: "#087E38",
    stroke: "#2A2E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0013 25.5662V32.7016L35.668 33.0875V23.8084L27.5 19V20.5L34.5157 24.7087C34.817 24.8894 35.0013 25.215 35.0013 25.5662Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDivide);
export default __webpack_public_path__ + "static/media/divide.2a6e1a7e28d4f6cef07a49b47f8e56aa.svg";
export { ForwardRef as ReactComponent };